<template>
  <div class="collectionAccountManagement container-style">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" :model="searchForm" class="form-inline">
        <el-form-item label="收款编号:">
          <el-input v-model="searchForm.merchantId" placeholder="请输入收款编号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <!-- <el-button @click.native="searchClick">
            查询
          </el-button> -->
           <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="loadingTable"></auth-button>
          </el-form-item>
      </el-form>
    </el-card>
     <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="loadingTable"
        :data="tableData"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          label="序号"
          type="index"
          width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="merchantId"
          label="收款编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="userName"
          label="收款账号"
          align="center">
        </el-table-column>
        <el-table-column
          label="关联门店"
          align="center">
          <template slot-scope="scope">
            <auth-button
              opt="details"
              type="text"
              label="查看"
              @click.native="goDetaill(scope.row,1)">
            </auth-button>
          </template>
        </el-table-column>
        <el-table-column
          label="变更日志"
          align="center">
           <template slot-scope="scope">
            <auth-button
              opt="details"
              type="text"
              label="查看"
              @click.native="goDetaill(scope.row,2)">
            </auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination :size="paginations.pageSize"  @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
import { getPayAccountList } from '@/api/merchant-info'
export default {
  components: {
    pagination
  },
  data () {
    return {
      searchForm: {
        merchantId: ''
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 1,
        pageSize: 10
      },
      loadingTable: false,
      tableData: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    goDetaill ({ merchantId }, type) {
      if (type === 1) {
        this.$router.push({
          path: '/MerchantSettle/AccountManage/relatedShop',
          query: {
            merchantId: merchantId
          }
        })
      } else {
        this.$router.push({
          path: '/MerchantSettle/AccountManage/changeLog',
          query: {
            merchantId: merchantId
          }
        })
      }
      console.log('type: ', type)
    },
    dateChange (value) {
      if (value !== null) {
        [this.searchForm.startTime, this.searchForm.endTime] = value
      } else {
        [this.searchForm.startTime, this.searchForm.endTime] = ['', '']
      }
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.getList()
    },
    searchClick () {
      this.paginations.pageNo = 1
      this.getList()
    },
    getList () {
      this.loadingTable = true
      const params = Object.assign(this.searchForm, this.paginations)
      console.log('params: ', params)
      getPayAccountList(params).then(response => {
        this.loadingTable = false
        if (+response.error_code === 0) {
          this.tableData = response.data.accountList
          this.paginations.count = response.data.total
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
